import { Component, OnInit, Input, Output, EventEmitter  } from '@angular/core';
import { FileItem, FileLikeObject, FileUploader } from 'ng2-file-upload';
import {
  faFileImport,
  faCloudUploadAlt,
} from '@fortawesome/free-solid-svg-icons';

import Swal from 'sweetalert2/dist/sweetalert2.js';
import { AppSettings } from 'src/app/appSettings';
import { ProductService } from 'src/app/services/product.service';

@Component({
  selector: 'app-import-file',
  templateUrl: './import-file.component.html',
  styleUrls: ['./import-file.component.scss'],
  host: { class: 'wrapper-import-file' },
})

export class ImportFileComponent implements OnInit {
  public changed: boolean = false;

  public uploader!: FileUploader;
  public hasBaseDropZoneOver: boolean = false;

  public faFileImport = faFileImport;
  public faCloudUploadAlt = faCloudUploadAlt;

  @Output() onChangeEvent = new EventEmitter<any>();
  @Output() onCancelEvent = new EventEmitter<any>();
  @Output() onSuccessEvent = new EventEmitter<any>();

  @Input() actions: boolean = false;
  @Input() inmodal: boolean = false;

  constructor(private _productService: ProductService) {
    /**
     *
     * envio do logo do estabelecimento
     *
     */

     this.uploader = new FileUploader({
      url: AppSettings.API_ENDPOINT,
      allowedFileType: ['xls'],
      maxFileSize: 1048576 * 2,
    });

    this.uploader.onAfterAddingFile = (f) => {
      f.withCredentials = false;

      if (this.uploader.queue.length > 1) {
        this.uploader.removeFromQueue(this.uploader.queue[0]);
      }

      this.changed = true;
      this.onChangeEvent.emit(true);
    };

    this.uploader.onCompleteItem = (
      item: any,
      response: any,
      status: number,
      headers: any
    ) => {
      console.log(response);
      if (status == 200) {
        var responsePath = JSON.parse(response);
        if (responsePath['success']) {
          // this.files.unshift(responsePath['file']);
          this.onSuccessEvent.emit(responsePath['file']);
        }
      }
    };

    this.uploader.onCompleteAll = () => {
      this.uploader.clearQueue();
      this.changed = false;
      this.onChangeEvent.emit(false);
      this.saveComplete();
    };

    this.uploader.onErrorItem = (
      item: FileItem,
      response: any,
      status: any,
      headers: any
    ) => {
      item.remove();

      Swal.fire(
        'Ops!',
        'Ocorreu um erro ao enviar a planilha, verifique se a planilha está correta! Se é um arquivo válido com no máximo 2 MB de tamanho',
        'error'
      );
    };

    this.uploader.onWhenAddingFileFailed = function (
      item: FileLikeObject,
      filter: any,
      options: any
    ) {
      Swal.fire(
        'Ops!',
        'O arquivo selecionado não é válido, verifique se é um arquivo de planilha com no máximo 2 MB de tamanho!',
        'error'
      );
    };
  }

  ngOnInit(): void {
  }

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  saveError() {
    Swal.fire('Ops!', 'Ocorreu um erro ao tentar enviar.', 'error');
  }

  saveComplete() {
    if (this.inmodal) {
      Swal.fire({
        title: 'O arquivo foi enviado com sucesso!',
        text: 'é possível verificar o status da importação em configurações > importação de dados',
        icon: 'success',
        showCancelButton: false,
        allowOutsideClick: false,
        showConfirmButton: true,
      });
    } else {
      Swal.fire('Enviado!', 'O arquivo foi enviado com sucesso!', 'success');
    }
  }

  saving() {
    Swal.fire({
      title: 'Enviando...',
      icon: 'info',
      showCancelButton: false,
      allowOutsideClick: false,
      showConfirmButton: false,
    });
  }

  onSubmit() {
    if (this.uploader.queue.length > 0) {
      this.saving();

      this.uploader.setOptions(this._productService.getUrlImportProducts());

      this.uploader.uploadAll();
    }
  }

  onCancelModalImport() {
    this.onCancelEvent.emit(true)
  }

  onSendFile() {
    this.onSubmit()
  }


}
